import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const PlusPlanImpactRows = ({ items }) => {
    return items.map((item, i) => {
        return (
            <div key={i} className="plus-plan__row">
                <div className="plus-plan__row--column_right"> {item.label}</div>
                <div className="plus-plan__row--column_left"> {item.value}</div>
            </div>
        )
    })
}

const PlusPlanImpactTable = ({ title, children }) => {
    return (
        <div className="plus-plan__table">
            <h3>{title}</h3>
            {children}
        </div>
    );
};

PlusPlanImpactTable.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
};

PlusPlanImpactRows.propTypes = {
    items: PropTypes.array
};

export { PlusPlanImpactTable, PlusPlanImpactRows }